<div class="row col-12 col-sm-12 manage-user-container my-account-container">
  <div class="col-3 col-sm-3 left-side my-account-left-nav">
    <app-my-account-left-sidenav [navState]="'UsersNavNode'"
    [childNavState]="'CompanyUsersNavNode'"></app-my-account-left-sidenav>
  </div>

  <div class="myAccountMyProfile col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav">
    <h1 class="manageUserTopHeader m-0">{{'common.text_company_users_label'|cxTranslate}}
    </h1>
    <div class="my-section-box">
      <div class="myProfileButtonContainer">
        <div class="my-section-box-inner">
          <div class="row">
            <div
              class="col-xs-12 col-sm-12 col-md-12 d-flex align-items-center justify-content-between title manage-user-block">
              <label
              class="company-users-section-headerline">{{'common.text_myCompanyManage_content'|cxTranslate}}</label>
              <a role="button" class="btn btn-default yellow-btn create-new-user-btn" (click)="addUser()">
                {{'common.text_company_manageUser_button_create'|cxTranslate}}<img class="arrow-icon"
                src="/icons/link-dark-grey.svg" alt="Link Icon">
              </a>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-9">
              <div class="form-group search-term-form-group">
                <label class="control-label">{{'common.mycompany_search_term'|cxTranslate}}</label>
                <div class="search-term-input-button d-flex">
                  <input name="text" [(ngModel)]="searchTerm"
                    class="form-control company-user-search-input" type="text" value=""
                    placeholder="{{'common.mycompany_enter_name_placeholder'|cxTranslate}}">
                    <button type="button" class="btn btn-default yellow-btn search-company-user-btn"
                      (click)="searchUser()">
                      {{'common.text_search'|cxTranslate}}<img class="arrow-icon"
                      src="/icons/link-dark-grey.svg" alt="Link Icon">
                    </button>
                    <input type="hidden" class="company-users-search-url"
                      value="/CH/en_GB/EUR/my-company/organization-management/manage-users">
                    </div>
                  </div>
                </div>
              </div>
              @if (!userList?.searchPageData.customerList) {
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 d-flex justify-content-center">
                    <label class="no-user">{{'common.text_company_manageUser_noUser'|cxTranslate}}</label>
                  </div>
                </div>
              }
            </div>

            @if (userList?.searchPageData && userList?.searchPageData?.customerList && userList?.searchPageData?.customerList.length>0) {
              <div class="sort-section"
                >
                <div class="gray-search-result-box">
                  {{totalResult}}
                  <div class="d-lg-none">
                    <div class="mobile-select">
                      <span class="mobile-select-label">Sort by:</span>
                      <div class="select-box">
                        <select class="mobile-sorting-dropdown form-control" (change)="sortDevice($event)"
                          name="sort">
                          <option value="byName">
                          Name-Asc</option>
                          <option value="byNameDesc">
                          Name-Desc</option>
                          <option value="byEmail">
                          Email-Asc</option>
                          <option value="byEmailDesc">
                          Email-Desc</option>
                          <option value="byActive">
                          Active-Asc</option>
                          <option value="byActiveDesc">
                          Active-Desc</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="account-overview-table mycompany-manageUser">
                  <table class="responsive-table table table-bordered table-blue managerUserTable">
                    <thead>
                      <tr class="responsive-table-head hidden-xs hidden-sm">
                        <th class="name" scope="col">
                          <a class="a-underline"
                            (click)="sort('name')"><span>{{'common.text_company_members_name_title'|cxTranslate}}</span></a>
                          </th>
                          <th class="email" scope="col">
                            <a class="a-underline"
                              (click)="sort('email')"><span>{{'common.text_account_quote_email'|cxTranslate}}</span></a>
                            </th>
                            <th scope="col">{{'common.text_user_table_header_order'|cxTranslate}}</th>
                            <th scope="col">{{'common.text_user_table_header_Warranty'|cxTranslate}}</th>
                            <th scope="col">{{'common.text_user_table_header_Core'|cxTranslate}}</th>
                            <th scope="col">
                              <a class="a-underline"
                                (click)="sort('active')"><span>{{'common.text_account_quote_active'|cxTranslate}}</span></a>
                              </th>
                              <th scope="col" class="action-btn"></th>
                            </tr>
                          </thead>
                          @if (userList) {
                            <tbody>
                              @for (item of userList?.searchPageData?.customerList; track item) {
                                <tr class="responsive-table-item"
                                  >
                                  <td class="responsive-table-cell name">
                                    <span
                                    class="mycompany-registration-lable d-lg-none">{{'common.text_company_members_name_title'|cxTranslate}}</span>
                                    <a (click)="editUser(item.displayUid)"><span
                                    class="mycompnay-registration-value pointer">{{item.name}}</span></a>
                                  </td>
                                  <td class="responsive-table-cell email">
                                    <span
                                    class="mycompany-registration-lable d-lg-none">{{'common.text_account_quote_email'|cxTranslate}}</span>
                                    <a (click)="editUser(item.displayUid)"><span
                                    class="mycompnay-registration-value pointer">{{item.displayUid}}</span></a>
                                  </td>
                                  <td class="responsive-table-cell">
                                    <span
                                    class="mycompany-registration-lable d-lg-none">{{'common.text_user_table_header_order'|cxTranslate}}</span>
                                    <span class="mycompnay-registration-value">
                                      <span [ngClass]="item.onlineOrdering?'dot green':'dot red'"></span>
                                    </span>
                                  </td>
                                  <td class="responsive-table-cell">
                                    <span
                                    class="mycompany-registration-lable d-lg-none">{{'common.text_user_table_header_Warranty'|cxTranslate}}</span>
                                    <span class="mycompnay-registration-value">
                                      <span
                                      [ngClass]="item.warrantyRights && item.warrantyRights.length>0?'dot green':'dot red'"></span>
                                    </span>
                                  </td>
                                  <td class="responsive-table-cell">
                                    <span
                                    class="mycompany-registration-lable d-lg-none">{{'common.text_user_table_header_Core'|cxTranslate}}</span>
                                    <span class="mycompnay-registration-value">
                                      <span
                                      [ngClass]="item.coreRights && item.coreRights.length>0?'dot green':'dot red'"></span>
                                    </span>
                                  </td>
                                  <td class="table-action myCompany-active responsive-table-cell">
                                    @if (item.active) {
                                      <button (click)="setDisable(item.displayUid)"><img
                                      src="/icons/checksign-green.svg" alt="Disable User"></button>
                                    }
                                    @if (!item.active) {
                                      <button (click)="setEnable(item.displayUid)"><img
                                      src="/icons/account-lock.png" alt="Enable User"></button>
                                    }
                                  </td>
                                  <td class="table-action table-action-btn action-btn">
                                    <img (click)="editUser(item.displayUid)" src="/icons/edit-icon.png"
                                      class="edit-icon pointer" alt="Edit User">
                                      <img class="del-user-img" (click)="deleteUser(item.displayUid)"
                                        src="/icons/close-red.svg" class="close-icon pointer" alt="Deletes User">
                                        <img (click)="retriggerEmail(item.displayUid)" src="/icons/mail-kb.svg"
                                          class="mail-icon pointer" alt="Trigger Email">
                                        </td>
                                      </tr>
                                    }
                                  </tbody>
                                }
                              </table>
                            </div>
                            <div class="legend-info-div">
                              <div class="legend-text" style="margin-bottom: 5px;">{{'common.mycompany_legend'|cxTranslate}}
                              </div>
                              <br>
                                <div class="legend-text">
                                  <img src="/icons/checksign-green.svg" class="checksign-icon" alt="Active user">
                                  {{'common.mycompany_active_user'|cxTranslate}}
                                </div>
                                <div class="legend-text">
                                  <img src="/icons/edit-icon.png" alt="Edit"> {{'common.text_account_quote_msg4'|cxTranslate}}
                                </div>
                                <div class="legend-text">
                                  <img src="/icons/close-red.svg" class="legend-close-icon"
                                    alt="delete User">{{'common.mycompany_click_delete_user'|cxTranslate}}
                                  </div>
                                  <div class="legend-text">
                                    <img src="/icons/account-lock.png" alt="Lock"
                                      class="glyphicon glyphicon-lock lock-icon">{{'common.text_account_quote_msg5'|cxTranslate}}
                                    </div>
                                  </div>
                                  <div class="account-orderhistory-pagination company-users-pagination">
                                    <div class="product__list--wrapper">
                                      <div class="pagination-bar">
                                        <div class="pagination-toolbar">
                                          <div class="row sort-refine-bar">
                                            <div class="col-xs-12 col-sm-6 col-md-6 bottom-result">
                                              <div class="pagination-result">
                                              {{totalResult}} </div>
                                            </div>
                                            <div class="col-xs-12 col-sm-6 col-md-6 kb-pagination-right kb-pagination">
                                              <kb-pagination [pagination]="$any(userList)?.searchPageData.pagination"
                                                [defaultPage]="0"
                                              (viewPageEvent)="changePageCustom($event, $any(userList)?.searchPageData)"></kb-pagination>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>